type Language = 'en-US' | 'ja-JP';

export const AVAILABLE_LANGUAGES: Language[] = ['en-US', 'ja-JP'];

export default Language;
